import React, { useState } from "react";
import { Button, Modal, Form, Spinner, Alert } from "react-bootstrap";
import { useEffect } from "react";

const CreateReportModal = ({
  onClose,
  onReportCreated,
  selectedProjectId,
  setSelectedProjectId,
}) => {
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const [summary, setSummary] = useState("");
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");

  const [projectId, setProjectId] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");

    fetch("https://loopsneller.com/api/projects", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch((err) => console.error("Failed to load projects", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMsg(null);

    const token = localStorage.getItem("auth_token");

    try {
      const res = await fetch("https://loopsneller.com/api/reports", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          type,
          data: JSON.stringify({
            summary,
            status,
            notes,
          }),
          project_id: projectId || null,
        }),
      });

      if (!res.ok) {
        const result = await res.json();
        throw new Error(result.message || "Failed to create report");
      }

      const result = await res.json();
      setSuccessMsg("Report created successfully!");

      // Reset form
      setType("");
      setSummary("");
      setStatus("");
      setNotes("");
      setProjectId("");

      if (onReportCreated) onReportCreated(result.report);

      // Close modal after a short delay
      setTimeout(() => {
        setShow(false);
        setSuccessMsg(null);
      }, 1500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        + Create Report
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>New Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger">{error}</Alert>}
            {successMsg && <Alert variant="success">{successMsg}</Alert>}

            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter report title"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Select
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
            >
              <option value="">All Projects</option>
              {projects.map((proj) => (
                <option key={proj.id} value={proj.id}>
                  {proj.name}
                </option>
              ))}
            </Form.Select>

            <Form.Group className="mb-3">
              <Form.Label>Summary</Form.Label>
              <Form.Control
                type="text"
                placeholder="Short summary"
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control
                type="text"
                placeholder="E.g. Completed, In Progress"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Additional notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </Form.Group>

            <Button type="submit" variant="success" disabled={loading}>
              {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateReportModal;
